import React, { useState,useContext, useEffect } from 'react';
import { Tooltip } from '@mui/material';
import JisInput from '../../components/controls/jisInput';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import JisTable from '../../components/controls/jisTable';
import JisDropdown from '../../components/controls/jisDropdown';
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';
import TiptapEditor from '../../components/controls/tip_tap_editor';
import JisYesNo from '../../components/controls/jisYesNo';

function EmailTemplate() {
  const {  activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
  const [recipients, setRecipients] = useState([]);
  const [html, setHtml] = useState('')
  const [activeTemplate, setActiveTemplate] = useState({id:0});
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNew, setIsNew]=useState(false);
const [icopy, setICopy] =useState(-1);
const [icopy2, setICopy2] =useState(-1);
const [open,setOpen] = useState(false);
 const pattern= /\[.+?\]/g
    const isClipboard= (window.isSecureContext && navigator.clipboard);

   useEffect(() => {
       // setActivePage({title:'Manage Role'});
   
        onLoad();
      }, []);

       useEffect(() => {
       // setActivePage({title:'Manage Role'});
        if(isNew){
            setActiveTemplate({id:0,subject:'',selectedRecipients:''})
        }   
      }, [isNew]);

   const onLoad= async()=>{
          //for account registration
          setLoading(true);
          try {
            setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/setup/email-templates`, { 
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
              });
              setLoading(false);
              const data = await resp.json();
                setTemplates(data.templates);
             
            } catch (error) {
              setLoading(false);
              console.error(error);
              
            }
      }

      const onSelectTem=(opt)=>{
         onLoadTem(opt.id);
      }

      const onLoadTem= async(id)=>{
          //for account registration
          setLoading(true);
          try {
            setLoading(true);
              const resp = await fetch(`${Constants.apiUrl}/setup/email-templates/${id}`, { 
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
              });
              setLoading(false);
              const data = await resp.json();
               setActiveTemplate(data.template);
               setHtml(Constants.b64decode(data.template.html))  ;
             
            } catch (error) {
              setLoading(false);
              console.error(error);
              
            }
      
        }
  const onTemplateChange = (e) => {
    setActiveTemplate({...activeTemplate, [e.target.name]: e.target.value})
}
      const onSaveTemplate =async()=>{
          //write the txt to pdf
         // setIsDialog(false)
          //this will save only item added
      
          try {
              const theurl=activeTemplate.id==0? `${Constants.apiUrl}/setup/email-templates`:`${Constants.apiUrl}/setup/email-templates/${activeTemplate.id}`;

              setLoading(true);
              var b4=Constants.b64encode(html); //btoa(html) ;
              //holdersid are the ids on the selected 
              //first get out all the Placeholder in the html text
           
              console.log('html content');
              console.log(html);
              var ttag= html.match(pattern);
              var placeholders='';
              if (ttag!=null && isNew ){
                const tags = Array.from(html.match(pattern))
                console.log('all availble tags')
                console.log(tags);
                //second retrieve all its of the selected placeholder
                //save that on.
                placeholders= tags.join(",");

              }
              
              
              var temp={...activeTemplate,placeholders,html:b4};

              const resp = await fetch(theurl, {
                method: 'POST',
                body: JSON.stringify(temp),
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
              });
              
              const responseData = await resp.json();
              setLoading(false);
              console.log(responseData);
              if (responseData.code === 0 ) {
                //on this back
               
                setAlert({open:true, title:`Save Email Template`, subtitle:`Template Saved`})
                onLoad();
              }else {
                  setAlert(  {icon:'warning', open:true,title:'Template', subtitle:responseData.status});
                
              }
            } catch (error) {
              setLoading(false);
              console.error(error);
             
            }
      }

      const onSaveTemplateData =async(e)=>{
        e.preventDefault();
          //write the txt to pdf
         // setIsDialog(false)
          //this will save only item added
      
          try {
              const theurl=`${Constants.apiUrl}/setup/email-templates-data/${activeTemplate.id}`;

              setLoading(true);
              var b4=Constants.b64encode(html); //btoa(html) ;
              //holdersid are the ids on the selected 
              //first get out all the Placeholder in the html text
           var atemp={...activeTemplate}
            
              
              
              var temp={id:atemp.id,placeholders:atemp.placeholders,recipients:atemp.recipients, 
                title:atemp.title, code:atemp.code, html:'',mainEntity:atemp.mainEntity};

              const resp = await fetch(theurl, {
                method: 'POST',
                body: JSON.stringify(temp),
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
              });
              
              const responseData = await resp.json();
              setLoading(false);
              console.log(responseData);
              if (responseData.code === 0 ) {
                //on this back
               
                setAlert({open:true, title:`Save Email Template`, subtitle:`Template Saved`})
               setOpen(false);
                onLoad();
              }else {
                  setAlert(  {type:'warning', open:true,title:'Template', subtitle:responseData.status});
                
              }
            } catch (error) {
              setLoading(false);
              console.error(error);
             
            }
      }
const onTapCopy =(v,index)=>{
    
    // if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
      .writeText(v)
      .then(() => {
       // setBttnText("COPIED");
        setICopy(index);
        setTimeout(function () {
          //setBttnText("COPY CODE");
          setICopy(-1);
        }, 3000);
      })
      .catch((err) => {

        console.log(err.message);
      });
    

    }
const onTapCopy2 =(v,index)=>{
    
    // if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
      .writeText(v)
      .then(() => {
       // setBttnText("COPIED");
        setICopy2(index);
        setTimeout(function () {
          //setBttnText("COPY CODE");
          setICopy2(-1);
        }, 3000);
      })
      .catch((err) => {

        console.log(err.message);
      });
    

    }
    const onUpdate=(n)=>{
        
        if(n){
            setActiveTemplate({id:0});
        }else{
            if(activeTemplate==null || activeTemplate.id==0){
               setAlert({icon:'warning', open:true, title:'Update Template', subtitle:"please select any of the template before you click update"})
        return; 
            }
            
        }
        setIsNew(n)
        setOpen(true);
    }
  return (
    <div>
      <h3>Email Templates</h3>
      {/* Add your login form UI here */}
      <div style={{display:'flex'}}>
        <div style={{width:200}}>
        <JisYesNo yes="New" no="Update" value={isNew} onChange={onUpdate} />
  
            <h3>Actions</h3>
             {templates?.map((opt) => (
                                            <div key={opt.id} className={`selected ${opt.id==activeTemplate.id?'active':''}`} onClick={()=>onSelectTem(opt)}>
                                                {opt.title}<br/>
                                                <span>code:{opt.code}</span>
                                            </div>
                                            ))} 
        </div>
        <div style={{width:200}}>
            <h3>Placeholders</h3>
            {activeTemplate?.placeholders?.split(',')?.map((v,index) => (
                                            <div key={index} className={`selected-disabled`} >
                                                {v}
                                                <div className="tap-copy" onClick={()=> onTapCopy(v,index)}>
                                    <div>{icopy==index?'COPIED':'Tap to Copy'} </div>
                                     <DynamicIcon iname="content_copy" />
                                </div>
                                            </div>
                                            ))} 
        </div>
        <div style={{flex:1}}>
            <div style={{display:'flex', flexDirection:'row'}}>
                <h3>Available Recipients</h3>
                {activeTemplate?.recipients?.split(',')?.map((v,index) => (
                                            <div key={index} className={`selected-disabled`} >
                                                {v}
                                                <div className="tap-copy" onClick={()=> onTapCopy2(v,index)}>
                                    <div>{icopy2==index?'COPIED':'Tap to Copy'} </div>
                                     <DynamicIcon iname="content_copy" />
                                </div>
                                            </div>
                                            ))}
            </div>
            <div>
                <div  className="input-group">
                    <label> Selected Recipient <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Recipients' name="selectedRecipients" value={activeTemplate.selectedRecipients} onChange={onTemplateChange} />  
                    </div>
                </div>
                                
              <div  className="input-group">
                    <label> Email Subject <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Subject' name="subject" value={activeTemplate.subject}  onChange={onTemplateChange} /> 
                    </div>
                </div>
            </div>
            <div>
                
            </div>
            <div>
                <h3>Email body</h3>
                <div style={{  padding: '20px' }}>
                            <TiptapEditor initialContent={html} onChange={(content) => setHtml(content)} />
                 </div>
                 <JisButton onClick={onSaveTemplate}>Save Template</JisButton>
            </div>
        </div>

      </div>
      <div>
        
      </div>

   {open && <JisDialogForm title="Save Template" onClose={()=>setOpen(false)}>
        <form onSubmit={onSaveTemplateData}>
            <div>
                <div  className="input-group">
                    <label>Action Code <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Code' name="code" value={activeTemplate.code} onChange={onTemplateChange} />  
                    </div>
                </div>
                <div  className="input-group">
                    <label>Action Title <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Title' name="title" value={activeTemplate.title} onChange={onTemplateChange} />  
                    </div>
                </div>
               <div  className="input-group">
                    <label>Main Entity <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Main Entity' name="mainEntity" value={activeTemplate.mainEntity} onChange={onTemplateChange} />  
                    </div>
                </div>
                <div  className="input-group">
                    <label> Recipient <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Recipients' required name="recipients" value={activeTemplate.recipients} onChange={onTemplateChange} />  
                    </div>
                </div>
                <div  className="input-group">
                    <label> Placeholders <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                    <input placeholder='Placeholders' required name="placeholders" value={activeTemplate.placeholders} onChange={onTemplateChange} />  
                    </div>
                </div>
                <JisButton type="submit">Save</JisButton>
            </div>
        </form>
      </JisDialogForm>}  
      <BackLoader open={loading} /> 
    </div>
  );
}

export default EmailTemplate;